(function ($, win) {
    'use strict';

    win.dk = win.dk || {};

    function buildContentAccordions() {
        function $getSection($heading, $content) {
            var panelId = win.dk.generateId('tpn-'),
                tabId = win.dk.generateId('tpn-'),
                anchor = $heading.attr('id') || win.dk.getIdentifierFromText($heading);
            return $('<div/>').append(
                $('<div tabindex="0" class="acc-section-title" role="tab"/>').attr({
                    id: tabId, 'aria-controls': panelId, 'data-anchor': anchor
                }).append($heading.removeAttr('id')),
                $('<div class="collapsing-section" role="tabpanel"/>').attr({
                    id: panelId,
                    'aria-labelledby': tabId
                }).append($content)
            );
        }

        $('.accordion').each(function () {
            var $accordion = $(this).removeClass('accordion').addClass('dk-accordion')
                    .attr({ role: 'tablist', 'aria-live': 'polite' }),
                $controls = $('<div class="dk-accordion-title" />').append(
                    $('<a href="javascript:void(0)" class="expand-all"/>')
                ),
                $holder = $('<div/>'),
                sections = [],
                j, k, h;
            for (j = 1; j <= 6; j++) {
                if ($accordion.children('h' + j).length > 0) {
                    h = 'h' + j;
                    break;
                }
            }
            h = h || 'h3';
            if (!$accordion.children().length) {
                if ($accordion.text().replace(/^\s*|\s*$/g, '')) {
                    $accordion.wrapInner('<p></p>');
                } else {
                    // Empty accordion; hide it
                    $accordion.hide();
                    return;
                }
            }
            $accordion.children().each(function () {
                var $me = $(this);
                if ($me.is(h) && !$me.is('[data-literal]')) {
                    sections.push([$me.clone(), $holder.clone()]);
                } else {
                    if (sections.length < 1) {
                        sections.push([$('<' + h + '>&nbsp;</' + h + '>'), $holder.clone()]);
                    }
                    sections.slice(-1)[0][1].append($me.clone());
                }
            });
            for (k = 0; k < sections.length; k++) {
                $holder.append(
                    $getSection(sections[k][0], sections[k][1].children())
                );
            }
            $accordion.empty().append($holder.children());
            if (!$accordion.is('[data-no-expand-all]')) {
                $accordion.before($controls);
            }
        });
    }

    function bindAccordions() {
        const expandLabels = {
            en: { expand: 'Expand All', collapse: 'Collapse All' },
            es: { expand: 'Expandir todo', collapse: 'Contraer todo' }
        };
        const isSpanishPage = $('.page-lang-es').length > 0;

        function getExpandLabel(isExpanded) {
            return function () {
                // `this` in this context is the expand link element
                const $parent = $(this).parent().next('.dk-accordion'),
                    localLang = $parent.is('[data-spanish]') ? 'es' : $parent.data('lang'),
                    hasLang = Object.keys(expandLabels).indexOf(localLang) >= 0,
                    lang = hasLang ? localLang : (isSpanishPage ? 'es' : 'en');
                return expandLabels[lang][isExpanded ? 'collapse' : 'expand'];
            };
        }

        // Collapse all accordion sections by default
        $('.dk-accordion .acc-section-title').removeClass('open');
        $('.dk-accordion .collapsing-section').hide();
        $('.dk-accordion-title .expand-all').text(getExpandLabel(false));

        $('.dk-accordion:not([data-ready])').each(function () {
            var $accordion = $(this),
                $toggleAll = $('.expand-all', $accordion.prev('.dk-accordion-title')),
                $sectionTitles = $('.acc-section-title', $accordion),
                $sectionContents = $('.collapsing-section', $accordion),
                anchors = [],
                isNoAnchors = $accordion.is('[data-no-anchors]');

            function updateHistory(hsh) {
                var title, path;
                if (isNoAnchors) { return; }
                if ('replaceState' in win.history) {
                    hsh = hsh || '';
                    hsh = hsh.length > 0 && hsh.charAt(0) !== '#' ? ('#' + hsh) : hsh;
                    if (hsh === '' || $.inArray(hsh, anchors) >= 0) {
                        title = $('title').text() || 'NIDDK';
                        path = win.location.pathname + win.location.search + hsh;
                        win.history.replaceState('', title, path);
                    }
                }
            }

            $toggleAll.off().on('click', function (e) {
                var expandAll = $sectionTitles.filter('.open').length < $sectionTitles.length;
                e.preventDefault();
                $(this).text(getExpandLabel(expandAll));
                $sectionTitles[expandAll ? 'addClass' : 'removeClass']('open').attr('aria-expanded', expandAll ? 'true' : null);
                $sectionContents[expandAll ? 'slideDown' : 'slideUp']();
                updateHistory();
                return false;
            });

            $sectionTitles.each(function () {
                var $title = $(this),
                    anchor = $title.attr('data-anchor') || win.dk.getIdentifierFromText($title),
                    $content = $title.next('.collapsing-section').attr('aria-labelledby', $title.attr('id')),
                    secHash = anchor ? ('#' + anchor) : null;

                if (secHash) { anchors.push(secHash); }

                $title.on('focus', function () {
                    var $me = $(this);
                    if (!$me.data('md') && !$me.hasClass('open') && !$accordion.data('off')) {
                        $me.trigger('click');
                    }
                }).on('mousedown', function () {
                    $(this).data('md', true);
                }).on('mouseup', function () {
                    $(this).removeData('md');
                }).on('click', function () {

                    if ($title.hasClass('open')) {
                        // Close the current section
                        $title.removeClass('open').removeAttr('aria-expanded');
                        $content.slideUp();
                        $toggleAll.text(getExpandLabel(false));
                        updateHistory();
                    } else {
                        // Close the other sections and open the new one
                        $sectionTitles.removeClass('open').removeAttr('aria-expanded');
                        $sectionContents.not($content).slideUp(); // Slide up all sections that are open & remove their open class
                        $title.addClass('open');
                        $content.slideDown(function () {
                            $('html,body').animate({
                                scrollTop: $title.offset().top - 75
                            }, 500);
                        });
                        updateHistory(secHash);
                    }
                }).data('anchor', secHash);
            });
            $accordion.attr('data-ready', true);
        });
    }

    win.dk.bindAccordions = bindAccordions;

    $(function () {
        if (!win.dk.isEditing) {
            // For accordions in body content, generate the accordion structure when not in edit mode
            buildContentAccordions();
        }

        // Disable the accordions when the window loses focus
        $(win).on('blur', function () {
            $('.dk-accordion').data('off', true);
        }).on('focus', function () {
            setTimeout(function () { $('.dk-accordion').removeData('off'); }, 50);
        });

        bindAccordions();

        // Open the accordion section if the page was loaded with an anchor link to it
        if (win.location.hash && !$('html').is('[data-no-accordion-anchors]')) {
            win.setTimeout(function () {
                $('.dk-accordion:not([data-no-anchors]) .acc-section-title').filter(function () {
                    return $(this).data('anchor') === win.location.hash;
                }).first().trigger('click');
            }, 300);
        }
    });
})(window.jQuery, window);
